// extracted by mini-css-extract-plugin
module.exports = {"bannerSection":"style_bannerSection__FLIcb","formBlock":"style_formBlock__NJWVF","contactInfo":"style_contactInfo__CC6uX","socialMenu":"style_socialMenu__WYNuh"};